



import Vue from 'vue'
import router from '@/router'
import { hasValidLogin, LOGIN_URL, popPostLoginRedirect } from '@/helpers/authHelper'

export default Vue.extend({
  name: 'Login',
  beforeMount: async function () {
    if (hasValidLogin()) {
      this.$store.dispatch('updateFromTokens')
      const path = popPostLoginRedirect()
      if (path) {
        router.push({ path })
      }
      if (this.$store.state.isMasqueradingReadOnly) {
        let masqueradeUser = this.$route.query?.masqueradeUser
        this.$store.commit('updateIdpId', masqueradeUser)
        router.push({ name: 'Profile' })
      } else if (this.$store.state.isLearner) {
        router.push({ name: 'Profile' })
      } else {
        router.push({ name: 'Dashboard' })
      }
    } else {
      location.replace(LOGIN_URL)
    }
  },
})
